export const env = { ...process.env, ...window['env'] }
// window.env = {
//     "REACT_APP_API_ENDPOINT": "http://localhost:3000"
//   }
